import { Dialog, Switch } from '@/components/ui';
import { CONSENT_CATALOG, type ConsentCategoryInfo } from '@/lib/consent';
import { CookieCatalogTable } from './CookieCatalogTable';

export interface CookieSettingsDialogProps {
  open: boolean;
  onClose: () => void;
}

function CategoryRow({ category }: { category: ConsentCategoryInfo }): JSX.Element {
  const headingId = `cookie-category-${category.id}`;
  return (
    <section className="cookie-category" aria-labelledby={headingId}>
      <div className="cookie-category__header">
        <h3 id={headingId} className="cookie-category__title">
          {category.title}
        </h3>
        <Switch checked disabled readOnly aria-label={`${category.title}: sempre ativos`} label="Sempre ativos" />
      </div>
      <p className="cookie-category__description">{category.description}</p>
      <details className="cookie-category__details">
        <summary>Ver os itens ({category.items.length})</summary>
        <CookieCatalogTable caption={`Itens da categoria ${category.title}`} items={category.items} />
      </details>
    </section>
  );
}

/**
 * O painel de preferências: uma linha por categoria do catálogo, com o
 * interruptor travado, a descrição e a tabela do que ela guarda. Só há
 * necessários, sempre ativos: o painel informa e não grava nada.
 */
export function CookieSettingsDialog({ open, onClose }: CookieSettingsDialogProps): JSX.Element | null {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      size="lg"
      title="Preferências de cookies"
      description="Usamos apenas cookies necessários ao funcionamento e às suas preferências: eles ficam sempre ativos."
    >
      <div className="cookie-settings">
        {CONSENT_CATALOG.map((category) => (
          <CategoryRow key={category.id} category={category} />
        ))}
      </div>
    </Dialog>
  );
}
